import React from 'react'
import SideBar from '../../components/SideBar/index'
import './styles.css'
import Background from '../../components/BackDrop/index'
import Cursor from '../../components/CustomCursor/index'
import LandingPage from './../landingPage/index'
import gsap, { Power4 } from 'gsap'
function BaseScreen() {
  let sideBar = React.useRef<HTMLDivElement>(null)
  React.useEffect(() => {
    gsap.from(sideBar, {
      opacity: 0,
      x: 200,
      duration: 2,
      ease: Power4.easeInOut,
    })
  }, [])
  return (
    <>
      <div className="base">
        <Cursor />
        <div className="container">
          <Background />
          <section id="Landing" className="landing">
            <LandingPage />
          </section>
          <section className="extended-landing">Extended First Page</section>
          <section id="Projects" className="projects">
            second Page
          </section>
          <section id="Blogs" className="blogs">
            third Page
          </section>
          <section id="Contact" className="contact">
            last Page
          </section>
        </div>
        <div className="navigation" ref={(ele) => (sideBar = ele)}>
          <SideBar />
        </div>
      </div>
    </>
  )
}

export default BaseScreen
